import request from '../../../../util/request';

export function uploadImgRequest(file, fileName, callback) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName);
    return request(
        '/upload',
        {
            method: 'POST',
            body: formData,
        },
        callback
    );
}

export function createBotRequest(
    space_id,
    name,
    description,
    icon_file_id,
    prompt,
    prologue,
    suggested_questions,
    callback
) {
    return request(
        '/cBot',
        {
            method: 'POST',
            body: {
                space_id,
                name,
                description,
                icon_file_id,
                prompt,
                prologue,
                suggested_questions,
            },
        },
        callback
    );
}



//创建知识库文件接口
export function createKcsFileList(data, callback) {
  return request(
    '/zhishiku/createDatasetsFile',
    {
      method: 'POST',
      body: data,
    },
    callback
  );
}

//修改知识库图片标注
export function updateImgCaption(data, callback) {
  return request(
    '/zhishiku/updateImgCaption',
    {
      method: 'POST',
      body: data,
    },
    callback
  );
}
//获取知识库文件上传进度
export function getDatasetsFileProcess(dataset_id,document_ids, callback) {
  return request(
    '/zhishiku/getDatasetsFileProcess',
    {
      method: 'POST',
      body: {
        dataset_id,
        document_ids
      },
    },
    callback
  );
}
